import { FC, PropsWithChildren } from 'react';

// todo: taken from apps/webapp-provider/src/ui/components/invoiceCard/components/InvoiceCard.tsx - DRY up
export const GridElement: FC<PropsWithChildren & { title?: string }> = ({
  children,
  title,
}) => {
  return (
    <div>
      {title && <p className="supporting-body text-gray-500">{title}</p>}
      {children}
    </div>
  );
};
